module.exports = __webpack_public_path__ + "img/up7.2f0e3d3d.png";